<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="container">
      <section class="section--listing-form">
        <client-only>
          <listing-form v-if="draftAccessReady" ref="listingForm" formProp="add" />
        </client-only>
      </section>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import { mapState } from 'vuex';
import ListingForm from '@/components/listing-form/index';
import { chooseListingDraft } from '@/services/listingDraftRecovery';
import { acquireListingDraftLock, releaseListingDraftLock } from '@/services/listingDraftLock';

export default {
  name: 'listing-form-add',
  components: {
    DefaultLayout,
    ListingForm,
  },
  // eslint-disable-next-line no-unused-vars
  async fetch({ store, params, route }) {
    store.commit('head/RESTORE_DEFAULT_VALUE', route);
    // store.dispatch('v2/listingForm/resetAllFormState');
    // let listingType = 'R'; // default
    // if (params.listingType) listingType = params.listingType;
    // if (!store.getters['global/allowAddSellListing']) listingType = 'R';
    // await store.commit('v2/listingForm/SET_LISTING_TYPE', listingType);
  },
  data() {
    return {
      e6: 1,
      draftAccessReady: false,
      draftLockHeld: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: this.$t('general.addProperty'),
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  methods: {
    navigateForm(index) {
      this.e6 = index;
    },
    async prepareDraftAccess() {
      if (!this.user || !this.user.uuid) return;
      this.draftLockHeld = await acquireListingDraftLock(this.user.uuid);
      if (!this.draftLockHeld) {
        await this.$swal({
          type: 'warning',
          title: 'Draft Sedang Dibuka',
          text: 'Tutup tab Add Listing lain sebelum melanjutkan.',
          confirmButtonText: 'Kembali',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        this.$router.replace('/');
        return;
      }
      if (!this.$route.query.draft && !this.$route.query.fresh) {
        try {
          const result = await chooseListingDraft(this, this.user.uuid);
          if (result.choice === 'continue') {
            await this.$router.replace({
              path: '/listing/add',
              query: { draft: result.draft.draftId },
            });
          } else if (result.choice === 'close') {
            this.releaseDraftAccess();
            await this.$router.replace('/');
            return;
          } else {
            await this.$router.replace({ path: '/listing/add', query: { fresh: '1' } });
          }
        } catch (_) {
          await this.$swal(
            'Draft Lokal Tidak Tersedia',
            'Form tetap dapat digunakan tanpa pemulihan lokal.',
            'warning',
          );
        }
      }

      if (this.$route.query.fresh) {
        await this.$router.replace({ path: '/listing/add' });
      }
      this.draftAccessReady = true;
    },
    releaseDraftAccess() {
      if (this.draftLockHeld) releaseListingDraftLock();
      this.draftLockHeld = false;
    },
  },
  mounted() {
    this.prepareDraftAccess();
    window.addEventListener('pagehide', this.releaseDraftAccess);
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.listingForm) await this.$refs.listingForm.flushLocalDraft();
    this.releaseDraftAccess();
    next();
  },
  beforeDestroy() {
    window.removeEventListener('pagehide', this.releaseDraftAccess);
    this.releaseDraftAccess();
  },
};
</script>
